import { IGameState } from '../../Game/IGameState';

export function selectBackCard(state: IGameState, payload: string) {
    return {
        ...state,
        playerState: {
            ...state.playerState,
            backcard: payload,
        },
    };
}
